import { SlaVerdict } from '../../../interfaces/panel-data';

/**
 * Shared by the exception table's badge and the delta strip's tooltip, so a cell and the row it drills
 * into cannot end up wording the same verdict two ways.
 */
export const VERDICT_LABELS: Record<SlaVerdict, string> = {
  WITHIN_SLA: 'Within SLA',
  AT_RISK: 'At risk',
  BREACHING: 'Breaching',
  BREACHED: 'Breached',
  // Neither "Failed, within SLA" nor "Failed, breached": nothing was compared against a budget, so the label
  // states what happened and concludes nothing. The strip's tooltip says why there is no margin.
  FAILED: 'Failed',
  NOT_REGISTERED: 'Not registered',
  STALE: 'Stale',
  UNMEASURED: 'Not measured',
};
